import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
import Switch from "react-switch"
const AddParametrage = props => {
  const [dateOuverture, setDateOuverture] = useState(new Date())
  const [dateFermuture, setDateFermuture] = useState(new Date())
  const [capaciteInterne, setCapaciteInterne] = useState(0)
  const [capaciteExterne, setCapaciteExterne] = useState(0)
  const [bonusMentionTresBien, setBonusMentionTresBien] = useState(0)
  const [bonusMentionBien, setBonusMentionBien] = useState(0)
  const [bonusMentionAssezBien, setBonusMentionAssezBien] = useState(0)
  const [matiereMinBonus1, setMatiereMinBonus1] = useState(0)
  const [matiereMaxBonus1, setMatiereMaxBonus1] = useState(0)
  const [bonusMatiere1, setBonusMatiere1] = useState(0)
  const [matiereMinBonus2, setMatiereMinBonus2] = useState(0)
  const [matiereMaxBonus2, setMatiereMaxBonus2] = useState(0)
  const [bonusMatiere2, setBonusMatiere2] = useState(0)
  const [creditMinFaible, setCreditMinFaible] = useState(0)
  const [creditMaxFaible, setCreditMaxFaible] = useState(0)
  const [bonusCreditFaible, setBonusCreditFaible] = useState(0)
  const [creditMinMoyen, setCreditMinMoyen] = useState(0)
  const [creditMaxMoyen, setCreditMaxMoyen] = useState(0)
  const [bonusCreditMoyen, setBonusCreditMoyen] = useState(0)
  const [bonusSessionControle, setBonusSessionControle] = useState(0)
  const [malusRedoublement, setMalusRedoublement] = useState(0)
  const [creditMinHaut, setCreditMinHaut] = useState(0)
  const [creditMaxHaut, setCreditMaxHaut] = useState(0)
  const [bonusCreditHaut, setBonusCreditHaut] = useState(0)
  
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    let convert_ouverture = dateOuverture
    let month_ouverture = "" + (convert_ouverture.getMonth() + 1)
    let day_ouverture = "" + convert_ouverture.getDate()
    let year_ouverture = convert_ouverture.getFullYear()
    if (month_ouverture.length < 2) month_ouverture = "0" + month_ouverture
    if (day_ouverture.length < 2) day_ouverture = "0" + day_ouverture
    let convertDate_ouverture = [year_ouverture, month_ouverture, day_ouverture].join("-")
    ///date_fermeture
    let convert_fermeture = dateFermuture
    let month_fermeture = "" + (convert_fermeture.getMonth() + 1)
    let day_fermeture = "" + convert_fermeture.getDate()
    let year_fermeture = convert_fermeture.getFullYear()
    if (month_fermeture.length < 2) month_fermeture = "0" + month_fermeture
    if (day_fermeture.length < 2) day_fermeture = "0" + day_fermeture
    let convertDate_fermeture = [year_fermeture, month_fermeture, day_fermeture].join("-")
    API.post("master/master/add", {
      annee_id,
      user_id,
      date_ouverture:convertDate_ouverture,
      date_fermeture:convertDate_fermeture,
      capacite_interne:capaciteInterne,
      capacite_externe:capaciteExterne,
      bonus_mention_tres_bien:bonusMentionTresBien,
      bonus_mention_bien:bonusMentionBien,
      bonus_mention_assez_bien:bonusMentionAssezBien,
      matiere_min_bonus1:matiereMinBonus1,
      matiere_max_bonus1:matiereMaxBonus1,
      bonus_matiere1:bonusMatiere1,
      matiere_min_bonus2:matiereMinBonus2,
      matiere_max_bonus2:matiereMaxBonus2,
      bonus_matiere2:bonusMatiere2,
      credit_min_faible:creditMinFaible,
      credit_max_faible:creditMaxFaible,
      bonus_credit_faible:bonusCreditFaible,
      credit_min_moyen:creditMinMoyen,
      credit_max_moyen:creditMaxMoyen,
      bonus_credit_moyen:bonusCreditMoyen,
      credit_min_haut:creditMinHaut,
      credit_max_haut:creditMaxHaut,
      bonus_credit_haut:bonusCreditHaut,
      malus_session_controle:bonusSessionControle,
      malus_redoublement:malusRedoublement,
    }).then(res => {
      toast.success(" 🔓✔️  Paramétrage ajoutée Avec succès", {
        containerId: "A",
      })
      props.setSection(1)
    })
  }
  useEffect(async () => {
    const res = await API.post("master/master/get_by_id", { annee_id }).then(res => {
      setDateFermuture(new Date(res.data.Master.date_fermeture))
      setDateOuverture(new Date(res.data.Master.date_ouverture))
      setCapaciteInterne(res.data.Master.capacite_interne)
      setCapaciteExterne(res.data.Master.capacite_externe)
      setBonusMentionTresBien(res.data.Master.bonus_mention_tres_bien)
      setBonusMentionBien(res.data.Master.bonus_mention_bien)
      setBonusMentionAssezBien(res.data.Master.bonus_mention_assez_bien)
      setBonusSessionControle(res.data.Master.malus_session_controle)
      setMalusRedoublement(res.data.Master.malus_redoublement)
      setMatiereMinBonus1(res.data.Master.matiere_min_bonus1)
      setMatiereMaxBonus1(res.data.Master.matiere_max_bonus1)
      setBonusMatiere1(res.data.Master.bonus_matiere1)
      setMatiereMinBonus2(res.data.Master.matiere_min_bonus2)
      setMatiereMaxBonus2(res.data.Master.matiere_max_bonus2)
      setBonusMatiere2(res.data.Master.bonus_matiere2)
      setCreditMinFaible(res.data.Master.credit_min_faible)
      setCreditMaxFaible(res.data.Master.credit_max_faible)
      setBonusCreditFaible(res.data.Master.bonus_credit_faible)
      setCreditMinMoyen(res.data.Master.credit_min_moyen)
      setCreditMaxMoyen(res.data.Master.credit_max_moyen)
      setCreditMinHaut(res.data.Master.credit_min_haut)
      setCreditMaxHaut(res.data.Master.credit_max_haut)
      setBonusCreditHaut(res.data.Master.bonus_credit_haut)
      setBonusCreditMoyen(res.data.Master.bonus_credit_moyen)
    })
  }, [])


  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {" Date d'ouverture :"}
                  </Label>
                  <Col md={12} className="pr-0">
                    <DatePicker
                      className="form-control ddate"
                      selected={dateOuverture}
                      value={dateOuverture}
                      onChange={e => setDateOuverture(e)}
                      dateFormat="dd/MM/yyyy"
                    />
                  </Col>
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {" Date de fermeture :"}
                  </Label>
                  <Col md={12} className="pr-0">
                    <DatePicker
                      className="form-control ddate"
                      selected={dateFermuture}
                      value={dateFermuture}
                      onChange={e => setDateFermuture(e)}
                      dateFormat="dd/MM/yyyy"
                    />
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Capacité interne :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Capacité interne"
                    type="number"
                    value={capaciteInterne}
                    onChange={e => setCapaciteInterne(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Capacité externe :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Capacité externe"
                    type="number"
                    value={capaciteExterne}
                    onChange={e => setCapaciteExterne(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus mention très bien :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus mention très bien"
                    type="number"
                    value={bonusMentionTresBien}
                    onChange={e => setBonusMentionTresBien(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus mention bien :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus mention bien"
                    type="number"
                    value={bonusMentionBien}
                    onChange={e => setBonusMentionBien(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus mention assez bien :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus mention assez bien"
                    type="number"
                    value={bonusMentionAssezBien}
                    onChange={e => setBonusMentionAssezBien(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus min matière 1 :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus min matière 1"
                    type="number"
                    value={matiereMinBonus1}
                    onChange={e => setMatiereMinBonus1(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus max matière 1 :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus max matière 1"
                    type="number"
                    value={matiereMaxBonus1}
                    onChange={e => setMatiereMaxBonus1(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus matière 1 :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus matière 1 "
                    type="number"
                    value={bonusMatiere1}
                    onChange={e => setBonusMatiere1(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus min matière 2 :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus min matière 2"
                    type="number"
                    value={matiereMinBonus2}
                    onChange={e => setMatiereMinBonus2(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus max matière 2 :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus max matière 2"
                    type="number"
                    value={matiereMaxBonus2}
                    onChange={e => setMatiereMaxBonus2(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus matière 2 :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus matière 2 "
                    type="number"
                    value={bonusMatiere2}
                    onChange={e => setBonusMatiere2(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Crédit min faible :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Crédit min faible"
                    type="number"
                    value={creditMinFaible}
                    onChange={e => setCreditMinFaible(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Crédit max faible :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Crédit max faible"
                    type="number"
                    value={creditMaxFaible}
                    onChange={e => setCreditMaxFaible(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus crédit faible :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus crédit faible "
                    type="number"
                    value={bonusCreditFaible}
                    onChange={e => setBonusCreditFaible(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Crédit min moyen :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Crédit min moyen"
                    type="number"
                    value={creditMinMoyen}
                    onChange={e => setCreditMinMoyen(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Crédit max moyen :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Crédit max moyen"
                    type="number"
                    value={creditMaxMoyen}
                    onChange={e => setCreditMaxMoyen(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus crédit moyen :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Bonus crédit moyen "
                    type="number"
                    value={bonusCreditMoyen}
                    onChange={e => setBonusCreditMoyen(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Crédit min haut :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Crédit min haut"
                    type="number"
                    value={creditMinHaut}
                    onChange={e => setCreditMinHaut(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Crédit max haut :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder=" Crédit max haut"
                    type="number"
                    value={creditMaxHaut}
                    onChange={e => setCreditMaxHaut(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="4">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus crédit haut :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Malus de redoublement "
                    type="number"
                    value={bonusCreditHaut}
                    onChange={e => setBonusCreditHaut(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Malus session contrôle :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Malus session contrôle"
                    type="number"
                    value={bonusSessionControle}
                    onChange={e => setBonusSessionControle(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Malus de redoublement :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Malus de redoublement "
                    type="number"
                    value={malusRedoublement}
                    onChange={e => setMalusRedoublement(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddParametrage)
AddParametrage.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
